import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProjectContext } from '../../pages/projects/ProjectContext';

const ProjectDetailPage = () => {
  const { id } = useParams();
  const { selectedProject, selectProject } = useContext(ProjectContext);

  useEffect(() => {
    selectProject(id);
  }, [id, selectProject]);

  if (!selectedProject) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>{selectedProject.name}</h1>
      <div className="gallery">
        {selectedProject.galleryImages.map((image, index) => (
          <img key={index} src={image} alt={`${selectedProject.name} ${index + 1}`} />
        ))}
      </div>
    </div>
  );
};

export default ProjectDetailPage;